import { AuthService } from '../security/auth.service';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { PUBLIC_LOGIN_PATH } from 'src/app/constants/NextGenConstants';

export const authorizationGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isUserAuthorized()) {
    return true;
  }

  router.navigate([PUBLIC_LOGIN_PATH]);
  return false;
};
